import { Service } from '@angular/core';
import { map, Observable } from 'rxjs';
import { KalaApiResponse } from '../models/kala-api.model';
import { ImeMarketType, OrdersListData } from '../models/order-response.model';
import { isTodayOrderState } from '../models/order.model';
import { BaseService } from './base.service';

@Service()
export class OpenOrdersService extends BaseService {
	getOpenOrders({
		market = ImeMarketType.Deposit,
		symbol,
		pageSize = 20
	}: { market?: ImeMarketType; symbol?: string | null; pageSize?: number | null } = {}): Observable<OrdersListData> {
		const endpoint = new URL(`${this.kalaApiPath}/orders`, this.kalaApiPath);
		endpoint.searchParams.set('market', market);

		if (pageSize !== null && pageSize !== undefined) {
			endpoint.searchParams.set('pageSize', pageSize.toString());
		}

		if (symbol) {
			endpoint.searchParams.set('symbol', symbol);
		}

		return this.http.get<KalaApiResponse<OrdersListData>>(endpoint.toString()).pipe(
			map(response => {
				if (!response.isSuccessful) {
					throw new Error(response.error?.message ?? 'Failed to load orders');
				}

				const data = response.data;
				if (!data?.items) {
					return data ?? { items: [], totalCount: 0 };
				}

				// The endpoint answers with the account's whole order history; only today's
				// states reach the list. `totalCount` is recounted so the header and the empty
				// state agree with what survived, rather than with the API's own total.
				const items = data.items.filter(order => isTodayOrderState(order.state));
				return { ...data, items, totalCount: items.length };
			})
		);
	}
}
